import to from "await-to-js";
import { useContext, useEffect } from "react";
import { useTranslation } from "react-i18next";

import { Button } from "../../../../components/Button/Button";
import { Table } from "../../../../components/Table/Table";
import { ModalsContext } from "../../../../context/modals.context";
import { AuthorisedPersonsContext } from "../../../../modules/obligee/authorisedPersons/authorisedPersons.context";
import { authorisedPersonsService } from "../../../../modules/obligee/authorisedPersons/authorisedPersons.service";
import { ISvaOvlascenaLicaListaProps } from "../../../../modules/obligee/authorisedPersons/authorisedPersons.types";
import { formatDateDDMMYY } from "../../../../utils/dateFormatter";
import style from "./AuthorizedPersons.module.scss";
import { AddAuthorizedPersonModal } from "./components/AddAuthorizedPersonModal/AddAuthorizedPersonModal";

export const AuthorizedPersons = () => {
  const { authorisedPersons, setAuthorisedPersons } = useContext(
    AuthorisedPersonsContext
  );
  const { handleUpdateModals, setError } = useContext(ModalsContext);
  const { t } = useTranslation();

  const getSvaOvlascenaLicaZaPreuzimanjeMarkica = async () => {
    const [err, res] = await to(
      authorisedPersonsService.getSvaOvlascenaLicaZaPreuzimanjeMarkica()
    );
    if (err || !res.success) return setError(res?.errorMessage);
    setAuthorisedPersons({
      ovlascenaLica: res.data,
    });
  };

  useEffect(() => {
    getSvaOvlascenaLicaZaPreuzimanjeMarkica();
  }, []);

  const colDef = [
    { title: t("TABLES.IME"), dataIndex: "ime" },
    { title: t("TABLES.PREZIME"), dataIndex: "prezime" },
    {
      title: t("TABLES.BROJ_LICNE_KARTE"),
      dataIndex: "brojLicneKarte",
    },
    {
      title: t("TABLES.DATUM_VAZENJA_OVLASCENJA_OD"),
      dataIndex: "datumVazenjaOvlascenjaOd",
      render: (date: any) => formatDateDDMMYY(date),
    },
    {
      title: t("TABLES.DATUM_VAZENJA_OVLASCENJA_DO"),
      dataIndex: "datumVazenjaOvlascenjaDo",
      render: (date: any) => formatDateDDMMYY(date),
    },
    {
      title: t("TABLES.AKTIVNO"),
      width: "90px",
      dataIndex: "aktivno",
      render: (status: boolean) => (status ? t("TABLES.DA") : t("TABLES.NE")),
    },
  ];

  const onRowHandler = (record: ISvaOvlascenaLicaListaProps) => ({
    onClick: () => {
      handleUpdateModals({
        modalVisible: "dodajOvlasceno",
        id: record.id,
        record: record,
      });
    },
  });

  return (
    <div className={style.mainContainer}>
      <AddAuthorizedPersonModal
        refetch={getSvaOvlascenaLicaZaPreuzimanjeMarkica}
      />
      <div id="authorized_persons_full_list">
        <h2>
          {t("AKCIZNE_MARKICE.SPISAK_OVLASCENIH_LICA_ZA_PREUZIMANJE_MARKICA")}
        </h2>
        <div className={style.buttonContainer}>
          <Button
            onClick={() =>
              handleUpdateModals({ modalVisible: "dodajOvlasceno" })
            }
            type="primary"
          >
            {t("AKCIZNE_MARKICE.DODAJ_OVLASCENO_LICE")}
          </Button>
        </div>
      </div>
      <Table
        columns={colDef}
        scrollConfig={["#authorized_persons_full_list"]}
        dataSource={authorisedPersons.ovlascenaLica}
        rowClassName="pointer"
        onRow={onRowHandler}
        name="obveznik-markice-ovlascena-lica-tabela"
      />
    </div>
  );
};
